const templatePicker = 'TemplatePicker';

// FETCH TEMPLATES
export const FETCH_TEMPLATES_REQUEST = `${templatePicker}/FETCH_TEMPLATES_REQUEST`;
export const FETCH_TEMPLATES_RESPONSE = `${templatePicker}/FETCH_TEMPLATES_RESPONSE`;

// CREATE NEW TEMPLATE
export const CREATE_TEMPLATE_REQUEST = `${templatePicker}/CREATE_TEMPLATE_REQUEST`;
export const CREATE_TEMPLATE_RESPONSE = `${templatePicker}/CREATE_TEMPLATE_RESPONSE`;
export const CREATE_BEE_TEMPLATE_REQUEST = `${templatePicker}/CREATE_BEE_TEMPLATE_REQUEST`;
export const CREATE_BEE_TEMPLATE_RESPONSE = `${templatePicker}/CREATE_BEE_TEMPLATE_RESPONSE`;

// IMPORT TEMPLATE
export const IMPORT_TEMPLATE_REQUEST = `${templatePicker}/IMPORT_TEMPLATE_REQUEST`;
export const IMPORT_TEMPLATE_RESPONSE = `${templatePicker}/IMPORT_TEMPLATE_RESPONSE`;

// CLONE TEMPLATE
export const CLONE_TEMPLATE_REQUEST = `${templatePicker}/CLONE_TEMPLATE_REQUEST`;
export const CLONE_TEMPLATE_RESPONSE = `${templatePicker}/CLONE_TEMPLATE_RESPONSE`;
export const CLONE_TEMPLATE_ERROR = `${templatePicker}/CLONE_TEMPLATE_ERROR`;

// TEMPLATE DETAILS
export const FETCH_TEMPLATE_DETAILS_REQUEST = `${templatePicker}/FETCH_TEMPLATE_DETAILS_REQUEST`;
export const FETCH_TEMPLATE_DETAILS_RESPONSE = `${templatePicker}/FETCH_TEMPLATE_DETAILS_RESPONSE`;
export const FETCH_TEMPLATE_DETAILS_ERROR = `${templatePicker}/FETCH_TEMPLATE_DETAILS_ERROR`;

// SENDERS
export const FETCH_SENDERS_REQUEST = `${templatePicker}/FETCH_SENDERS_REQUEST`;
export const FETCH_SENDERS_RESPONSE = `${templatePicker}/FETCH_SENDERS_RESPONSE`;
export const FETCH_SENDERS_ERROR = `${templatePicker}/FETCH_SENDERS_ERROR`;

// FETCH CAMPAIGN DETAILS
export const FETCH_CAMPAIGN_DETAILS_REQUEST = `${templatePicker}/FETCH_CAMPAIGN_DETAILS_REQUEST`;
export const FETCH_CAMPAIGN_DETAILS_RESPONSE = `${templatePicker}/FETCH_CAMPAIGN_DETAILS_RESPONSE`;
export const FETCH_CAMPAIGN_DETAILS_ERROR = `${templatePicker}/FETCH_CAMPAIGN_DETAILS_ERROR`;

/* CAMPAIGN SPECIFIC ACTIONS */
export const CREATE_CAMPAIGN_TEMPLATE_REQUEST = `${templatePicker}/CREATE_CAMPAIGN_TEMPLATE_REQUEST`;
export const CREATE_CAMPAIGN_TEMPLATE_RESPONSE = `${templatePicker}/CREATE_CAMPAIGN_TEMPLATE_RESPONSE`;
export const CREATE_CAMPAIGN_TEMPLATE_ERROR = `${templatePicker}/CREATE_CAMPAIGN_TEMPLATE_ERROR`;

export const COPY_TEMPLATE_TO_CAMPAIGN_REQUEST = `${templatePicker}/COPY_TEMPLATE_TO_CAMPAIGN_REQUEST`;
export const COPY_TEMPLATE_TO_CAMPAIGN_RESPONSE = `${templatePicker}/COPY_TEMPLATE_TO_CAMPAIGN_RESPONSE`;
export const COPY_TEMPLATE_TO_CAMPAIGN_ERROR = `${templatePicker}/COPY_TEMPLATE_TO_CAMPAIGN_ERROR`;

export const FETCH_DATA_FEEDS_REQUEST = `${templatePicker}/FETCH_DATA_FEEDS_REQUEST`;
export const FETCH_DATA_FEEDS_RESPONSE = `${templatePicker}/FETCH_DATA_FEEDS_RESPONSE`;
export const FETCH_DATA_FEEDS_ERROR = `${templatePicker}/FETCH_DATA_FEEDS_ERROR`;

export const FETCH_MEMBER_DATA_REQUEST = `${templatePicker}/FETCH_MEMBER_DATA_REQUEST`;
export const FETCH_MEMBER_DATA_RESPONSE = `${templatePicker}/FETCH_MEMBER_DATA_RESPONSE`;
export const FETCH_MEMBER_DATA_ERROR = `${templatePicker}/FETCH_MEMBER_DATA_ERROR`;
